<template>
  <div>
    <label v-if="label">
      <StrongText>{{ label }}</StrongText>
    </label>
    <div class="group">
      <radio-button label="P" value="P" v-model="size" />
      <radio-button label="M" value="M" v-model="size" />
      <radio-button label="G" value="G" v-model="size" />
      <radio-button label="GG" value="GG" v-model="size" />
    </div>
  </div>
</template>

<script>
import FormElementStyle from '@/components/FormElementStyle'
import StrongText from '@/components/StrongText'

import RadioButton from '@/components/RadioButton'

export default {
  name: 'Check',
  props: {
    label: String,
  },
  components: {
    StrongText,
    FormElementStyle,
    RadioButton,
  },
  data: () => ({
    size: ''
  })
}
</script>

<style lang="scss" scoped>
.group {
  margin-top: 11px;
  margin-bottom: 60px;
}
.square {
  border: 1px solid;
  background: #fff;
  height: 24px;
  width: 24px;
  display: inline-block;
  margin-right: 8px;
}
ul {

}
li {
  display: inline-block;
  margin-right: 50px;
  font-size: 15px;
  &:last-child {
    margin-right: 0;
  }
  span {
    position: relative;
    top: -6px;
    font-weight: 400;
  }
}
</style>
